import { Component, OnInit, EventEmitter, Input, Output, AfterViewInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { PaymentService } from 'src/app/services/payment.service';

import { NoteBalanceAdjustmentsListItem } from 'src/app/models/payment';

@Component({
  selector: 'app-note-balance-adjustments-list',
  templateUrl: './note-balance-adjustments-list.component.html',
  styleUrls: ['./note-balance-adjustments-list.component.scss']
})
export class NoteBalanceAdjustmentsListComponent implements OnInit, AfterViewInit {
  private _participantId = null;
  private _noteId = null;

  @Input()
  set participantId(participantId: number) {
    this._participantId = participantId || null;
    this.getData();
  }
  get participantId(): number {
    return this._participantId;
  }

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || null;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  @Output() dataReturned = new EventEmitter<NoteBalanceAdjustmentsListItem[]>();

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  noteBalanceAdjustmentsList: NoteBalanceAdjustmentsListItem[] = [];

  // DataTable
  tableDisplayedColumns = [
    'adjustmentDate',
    'adjustmentId',
    'transactionAmount',
    'principalAmount',
    'interestAmount',
    'feeAmount',
    'adjustmentDescription'
  ];
  tableDataSource = new MatTableDataSource<NoteBalanceAdjustmentsListItem>(this.noteBalanceAdjustmentsList);
  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  noteBalanceAdjustmentsListFound = false;

  constructor(private _errorHandler: ErrorHandler, private _paymentService: PaymentService, public media: MediaObserver) {
    this._handleError = _errorHandler.createHandleError('NoteBalanceAdjustmentsListComponent');
  }

  ngOnInit() {
    this.noteBalanceAdjustmentsListFound = true;
    this.tableDisplayStyle = this.noteBalanceAdjustmentsListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.noteBalanceAdjustmentsListFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  ngAfterViewInit() {}

  getData(): void {
    if (this._participantId !== null && this._noteId !== null) {
      this.showSpinner = true;
      this.getNoteBalanceAdjustmentsList(this._participantId, this._noteId);
    }
  }

  getNoteBalanceAdjustmentsList(participantId: number, noteId: number): void {
    this.showSpinner = true;
    this._paymentService.getNoteBalanceAdjustmentsList(participantId, noteId).subscribe(
      resultArray => {
        this.noteBalanceAdjustmentsList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteBalanceAdjustmentsListComponent.getNoteBalanceAdjustmentsList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteBalanceAdjustmentsListComponent.getNoteBalanceAdjustmentsList :: result = ' + JSON.stringify(resultArray));
        }
        this.tableDataSource = new MatTableDataSource<NoteBalanceAdjustmentsListItem>(this.noteBalanceAdjustmentsList);
        this.noteBalanceAdjustmentsListFound = resultArray.length > 0;
        this.tableDisplayStyle = this.noteBalanceAdjustmentsListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
        this.tableDisplayStyleIE = this.noteBalanceAdjustmentsListFound
          ? this._showElementDisplayStyleIE
          : this._hideElementDisplayStyle;
        this.dataReturned.emit(this.noteBalanceAdjustmentsList);
        this.getDataComplete();
      },
      error => this._handleError('getNoteBalanceAdjustmentsList', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }
}
